/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const collectionChallengeWithClipsItemSchema = z.object({
  id: z.number(),
  challengeId: z.number(),
  group: z.string().nullable(),
  sortOrder: z.number(),
  title: z.string(),
  slug: z.string(),
  type: z.string(),
  triageStatus: z.string(),
  published: z.number(),
  totalClips: z.number(),
  approvedClips: z.number(),
  rejectedClips: z.number(),
});

export type ICollectionChallengeWithClipsItem = z.infer<
  typeof collectionChallengeWithClipsItemSchema
>;

export const listCollectionChallengesWithClipsResponseDataSchema = z.array(
  collectionChallengeWithClipsItemSchema,
);

export type IListCollectionChallengesWithClipsResponseData = z.infer<
  typeof listCollectionChallengesWithClipsResponseDataSchema
>;

export const listCollectionChallengesWithClipsResponseSchema = createApiResponseSchema(
  listCollectionChallengesWithClipsResponseDataSchema,
) as z.ZodSchema<IAPI<IListCollectionChallengesWithClipsResponseData>>;

export type IListCollectionChallengesWithClipsResponse =
  IAPI<IListCollectionChallengesWithClipsResponseData>;
